import React from "react";
import {
  FaReact,
  FaHandPointRight,
  FaDatabase,
  FaMapMarkerAlt,
  FaEnvelope,
  FaDownload,
  FaPhoneAlt,
  FaNodeJs,
  FaTools,
  FaHome
} from "react-icons/fa";

const data = {
  homeDetails:
    "Full Stack Developer with a passion for building beautiful and functional web applications.",
  homeTitle: "Welcome to my personal portfolio",
  projectTitle: "Projects",
  projectCategories: ["All", "Full-Stack", "Frontend", "Mobile", "API"],
  projectShowMore: "View More Projects",
  projectShowLess: "Show Less",
  technoTitle: "Technologies",
  download: <FaDownload aria-hidden="true" />,
  technoInfo:
    "I have a broad skill set across the full stack — from crafting pixel-perfect React/Next.js UIs to building scalable APIs with Node.js, NestJS, and FastAPI, backed by both SQL and NoSQL databases.",
  titleAbout: "About me",
  infoAbout:
    "I'm Mwafrika Josué, a Full Stack Developer specializing in modern web technologies. I build web applications, SaaS platforms, and APIs for businesses. I enjoy solving complex engineering challenges and continuously expanding my skills across the stack.",
  experienceTitle: "Experience",
  experienceInfo:
    "A snapshot of my professional journey — from distributed remote teams to on-site engagements and volunteer mentoring.",
  experience: [
    {
      id: 1,
      role: "Full-Stack Developer",
      company: "Consumatech Solutions",
      period: "Sep 2022 – Apr 2024, Jul 2026 – Present",
      location: "Cape Town, South Africa (Remote)",
      impact:
        "Building Cashout Live, a mobile trivia game for MTN Nigeria — an offline-first player PWA, a live game-show broadcast suite, and a USSD/SMS channel, backed by NestJS, PostgreSQL, and Redis.",
    },
    {
      id: 2,
      role: "Mid-Senior Developer",
      company: "byFood",
      period: "Jul 2024 – 2025",
      location: "Tokyo, Japan (Remote)",
      impact:
        "Shipped full-stack features in Go and Next.js/TypeScript for a food & travel platform, and improved organic visibility through SEO best practices.",
    },
    {
      id: 3,
      role: "Mid-Senior Developer",
      company: "Rabsh Stability",
      period: "2025 – Jun 2026",
      location: "Kinshasa, DRC (On-site)",
      impact:
        "Built and hardened Node.js/Express APIs on PostgreSQL, focused on performance, security, and smooth integration with relational data.",
    },
    {
      id: 4,
      role: "Mentor (Volunteer)",
      company: "Microverse",
      period: "Feb 2020 – Jul 2022",
      location: "Remote",
      impact:
        "Mentored 5+ junior developers, cutting coding errors by ~20% and improving code quality through pair programming and review.",
    },
  ],
  imageAbout:
    "https://res.cloudinary.com/ujuzi/image/upload/v1653783195/mes%20documents/IMG_4892_gqppaj.jpg",
  cards: [
    {
      id: 1,
      category: "Full-Stack",
      image: "/images/cashout-player.jpg",
      alt: "Cashout Live Player PWA home screen showing the daily 10-question quiz card and points dashboard",
      title: "Cashout Live — Player App",
      technologies: ["Next.js 15", "React 19", "PWA", "IndexedDB", "MSISDN Auth"],
      info: "Cashout Live is a mobile trivia game launching with MTN Nigeria: subscribers get a set number of questions every day, earn points for correct answers, and climb a leaderboard for daily, weekly, and monthly prizes — with the option to buy extra questions once the daily set runs out. This is the player-facing Progressive Web App: installable, offline-first, and phone-number authenticated.",
      live: "https://staging.cashoutlive.ng/know",
    },
    {
      id: 2,
      category: "Frontend",
      image: "/images/cashout-gameshow.jpg",
      alt: "Cashout Live Game Show - live entertainment landing page with live viewer count and prize pool",
      title: "Cashout Live — Game Show",
      technologies: ["Next.js", "React", "BroadcastChannel", "Tailwind CSS"],
      info: "The live game-show side of Cashout Live, where top players compete head-to-head online in real time — moderated by a live host and watched by spectators. Built as a single Next.js codebase covering Host Console, Contestant, Spectator, and a broadcast-safe Live Display, all kept in sync across browser tabs so a full show can run from one machine.",
      live: "https://staging-game-show.cashoutlive.ng/",
    },
    {
      id: 3,
      category: "Frontend",
      image: "/images/cashout-ussd.jpg",
      alt: "Cashout Live feature-phone simulator showing a USSD menu for the trivia game on MTN",
      title: "Cashout Live — USSD/SMS Simulator",
      technologies: ["Next.js", "React", "USSD", "SMS Gateway"],
      info: "A feature-phone channel for Cashout Live, bringing the daily trivia game — subscribing, answering questions, checking points and the leaderboard — to MTN subscribers without a smartphone, over USSD and SMS.",
      live: "https://staging-ussd-simulator.cashoutlive.ng/simulator",
    },
    {
      id: 4,
      category: "Full-Stack",
      image: "/images/cawi.jpg",
      alt: "CAWI - Congo Animal Welfare Initiative nonprofit platform showing campaigns page",
      title: "CAWI",
      technologies: ["Next.js", "TypeScript", "next-intl", "TanStack Query", "Express", "Prisma"],
      info: "A bilingual platform for the Congo Animal Welfare Initiative, a nonprofit protecting animals across the DR Congo. Features programs, campaigns, news, an online donation flow, and an admin portal for content management, built with Next.js on the frontend and an Express/Prisma/PostgreSQL API.",
      code: "https://github.com/mwafrika/cawi-congo",
      live: "https://congoanimalwelfareinitiative.com/",
    },
    {
      id: 5,
      category: "Full-Stack",
      image: "/images/ilovecv.jpg",
      alt: "ILoveCV - AI-powered resume builder landing page",
      title: "ILoveCV",
      technologies: ["Next.js", "TypeScript", "Supabase", "Gemini AI", "Zustand", "next-intl"],
      info: "An AI-powered resume builder that lets users craft polished, ATS-friendly resumes with drag-and-drop section editing, premium templates, Gemini-powered content suggestions, and one-click PDF export. Built with Next.js, Supabase for auth/storage, and next-intl for bilingual support.",
      code: "https://github.com/mwafrika/MakeMyCV",
      live: "https://make-my-cv-eight.vercel.app/",
    },
    {
      id: 6,
      category: "Frontend",
      image:
        "https://i.ibb.co/BK1Hn0x/Screenshot-2022-08-08-at-4-05-48-PM.png",
      alt: "Modern landing page with hero and feature sections",
      title: "Modern Landing Page",
      technologies: ["React", "Tailwind CSS", "Vite"],
      info: "A complete modern marketing website built with React, TailwindCSS and Vite — fast, responsive, and production-ready.",
      code: "https://github.com/mwafrika/Modern-landing-page",
      live: "https://modern-landing-page2.netlify.app/",
    },
    {
      id: 7,
      category: "Frontend",
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1650092446/portfolio_images/FireShot_Capture_008_-_CMS_Blog_-_blog-with-cms.vercel.app_w3pkph.png",
      alt: "GraphCMS blog application with featured posts",
      title: "GraphCMS Blog",
      technologies: ["Next.js", "Tailwind CSS", "GraphQL", "GraphCMS"],
      info: "A fully responsive CMS-powered blog with featured posts, categories, markdown articles, author information, and comments.",
      code: "https://github.com/mwafrika/GraphCMS-Blog",
      live: "https://blog-with-cms.vercel.app/",
    },
    {
      id: 8,
      category: "Mobile",
      image: "/images/chuck-norris.jpg",
      alt: "Chuck Norris jokes mobile app screen",
      title: "Chuck Norris App",
      technologies: ["React Native", "TypeScript", "Styled-components"],
      info: "A mobile app that displays random Chuck Norris jokes by category, built with React Native and TypeScript.",
      code: "https://github.com/mwafrika/chuck-test-sovetech",
      live: "https://res.cloudinary.com/ujuzi/video/upload/v1660853712/XRecorder_18082022_215959_lrkth0.mp4",
    },
    {
      id: 9,
      category: "Full-Stack",
      image:
        "https://res.cloudinary.com/ujuzi/image/upload/v1670286381/Kevent/huntify_iw4jnf.png",
      alt: "Huntify job tracking application dashboard",
      title: "Huntify",
      technologies: ["MERN Stack", "Context API", "Styled-components"],
      info: "Huntify tracks your job applications and keeps your job search organized — all in one place. No more spreadsheets, no more lost applications.",
      code: "https://github.com/mwafrika/jobifyMev2",
      live: "https://huntify.netlify.app",
    },
  ],
  technologies: [
    {
      id: 1,
      icon: <FaReact className="text-[#61DAFB] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Frontend",
      list: [
        "React / React Native",
        "Next.js",
        "TypeScript",
        "Redux / Zustand",
        "Tailwind CSS",
        "HTML5 & CSS3",
      ],
    },
    {
      id: 2,
      icon: <FaNodeJs className="text-[#68A063] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Backend",
      list: [
        "Node.js / Express",
        "NestJS",
        "FastAPI (Python)",
        "Ruby on Rails",
        "REST APIs",
        "Celery & Redis",
      ],
    },
    {
      id: 3,
      icon: <FaDatabase className="text-[#336791] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "Database & ORM",
      list: [
        "PostgreSQL",
        "MySQL / MongoDB",
        "Prisma / TypeORM",
        "Sequelize",
        "Redis",
      ],
    },
    {
      id: 4,
      icon: <FaTools className="text-[#f97316] text-2xl" aria-hidden="true" />,
      point: <FaHandPointRight aria-hidden="true" />,
      title: "DevOps & Tools",
      list: [
        "Docker & Docker Compose",
        "Git & GitHub",
        "CI/CD (GitHub Actions)",
        "Vercel / Netlify / DigitalOcean",
        "Jest / Mocha / Chai",
        "Postman / Swagger",
      ],
    },
  ],
  contact: {
    title: "Contact me",
    subTitle: "Let's get in touch",
    info: "I'm always open to new opportunities and collaborations. If you have a project in mind or just want to say hi, feel free to reach out.",
    list: [
      {
        id: 1,
        icon: <FaMapMarkerAlt className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "Kigali, Rwanda",
      },
      {
        id: 2,
        icon: <FaEnvelope className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "mwafrikajosue@gmail.com",
        href: "mailto:mwafrikajosue@gmail.com",
      },
      {
        id: 3,
        icon: <FaPhoneAlt className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "(+243) 995 220 038",
        href: "tel:+243995220038",
      },
      {
        id: 4,
        icon: <FaHome className="text-violet-400 text-lg mt-1" aria-hidden="true" />,
        title: "(+250) 795 433 710",
        href: "tel:+250795433710",
      },
    ],
  },
  menu: [
    { id: 1, name: "Home", url: "/#home" },
    { id: 2, name: "About", url: "/#about" },
    { id: 3, name: "Projects", url: "/#projects" },
    { id: 4, name: "Skills", url: "/#tech" },
    { id: 5, name: "Experience", url: "/#experience" },
    { id: 6, name: "Contact", url: "/#contact" },
  ],
};

export default data;
